<div class="wrapper" [ngClass]="{ 'manual-size': isPreviewMode() }">
  <main>
    <div class="container themeWhite">
      <div class="wrap">
        @if (!config().headerVideoUrl) {
          <div class="header_headerWrap__sm0sn">
            <div class="header_btnPrev__pPaHv">
              <div class="header_btnPrevImg__QPpZY">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"></path>
                </svg>
              </div>
            </div>
            <div class="header_btnPoint__9sJM4">
              <div class="header_btnPointImg__nx6po">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path
                    d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        }

        @if (config().headerVideoUrl) {
          <div class="header_header__6NUB2 header_headerVideo__LbjSi">
            <div class="header_content__Y5WcG">
              <div class="cWin">
                <div class="header_videoWrap__iF617">
                  <div
                    id="player"
                    style="
                      width: 100%;
                      height: 100%;
                      padding: 0px;
                      word-spacing: normal;
                      position: relative;
                      box-sizing: content-box !important;
                      text-align: left;
                      user-select: none;
                      font-family: sans-serif;
                      min-height: 15px;
                      font-size: 14px;
                      line-height: 1em;
                      direction: ltr;
                      color-scheme: none;
                    "
                  >
                    @if (config().headerVideoUrl.includes('youtu')) {
                      <app-youtube-player
                        [wide]="true"
                        [videoId]="previewYoutubeVideoId"
                        [isPreviewMode]="isPreviewMode()"
                      ></app-youtube-player>
                    } @else if (config().headerVideoUrl.includes('vimeo')) {
                      <app-vimeo-player [videoUrl]="config().headerVideoUrl"></app-vimeo-player>
                    } @else if (config().headerVideoUrl) {
                      <app-player [videoUrl]="config().headerVideoUrl"></app-player>
                    }
                  </div>
                  <div class="header_videoBotGrad__qdhaK"></div>
                  <div class="header_videoBtnTrailer__yDziR">
                    <button><i class="google-material-icons" aria-hidden="true">play_arrow</i>Trailer</button>
                  </div>
                </div>
                <div class="header_topContent__fuFtX">
                  <div class="header_iconNameContent__uY1ks">
                    <picture>
                      <img class="header_iconImage__kRTYQ" alt="icon" [src]="config().logo?.image" />
                    </picture>
                    <div>
                      <h1 class="header_name__wDmB9">
                        <span>
                          {{ previewContent.name }}
                          <svg
                            viewBox="0 0 512 512"
                            preserveAspectRatio="xMidYMid meet"
                            style="
                              width: 32px;
                              height: 36px;
                              transform: translate3d(0px, 0px, 0px);
                              content-visibility: visible;
                              vertical-align: middle;
                              padding-bottom: 4px;
                            "
                          >
                            <defs>
                              <clippath id="__lottie_element_2">
                                <rect width="512" height="512" x="0" y="0"></rect>
                              </clippath>
                              <clippath id="__lottie_element_4">
                                <path d="M0,0 L512,0 L512,512 L0,512z"></path>
                              </clippath>
                            </defs>
                            <g clip-path="url(#__lottie_element_2)">
                              <g
                                clip-path="url(#__lottie_element_4)"
                                transform="matrix(0.6499999761581421,0,0,0.6499999761581421,-4.399993896484375,79.60000610351562)"
                                opacity="1"
                                style="display: block"
                              >
                                <g transform="matrix(1,0,0,1,256,256)" opacity="1" style="display: block">
                                  <g opacity="1" transform="matrix(0.8999999761581421,0,0,0.8999999761581421,0,0)">
                                    <path
                                      fill="rgb(68,163,221)"
                                      fill-opacity="1"
                                      d=" M102.375,-248.5 C63,-263 32.5,-223.25 0.75,-222.625 C-31,-222 -63.75,-263 -101,-249.125 C-138.25,-235.25 -134,-184 -154.81199645996094,-159.375 C-175.62399291992188,-134.75 -229.5,-143.75 -248,-102.93800354003906 C-264.6600036621094,-66.18399810791016 -222,-31.5 -222,0.18700000643730164 C-222,33.25299835205078 -263,65.625 -248.375,102.81199645996094 C-233.75,140 -181.25,135.75 -158,156.75 C-134.75,177.75 -141,235.75 -99.75,249.125 C-58.5,262.5 -23.25,223 0.625,222.375 C24.5,221.75 62.874000549316406,261.5 101.56199645996094,249.25 C140.25,237 135.5,179.5 157.125,158 C178.75,136.5 234.75,139.5 249.5,101.875 C264.25,64.25 223,26.75 222.75,-1.25 C222.5,-29.25 262.5,-63 249.375,-101.25 C236.25,-139.5 183,-133.5 158.75,-156 C134.5,-178.5 141.75,-234 102.375,-248.5z"
                                    ></path>
                                  </g>
                                </g>
                                <g
                                  transform="matrix(0.9929699897766113,0,0,1.0264699459075928,253.8919219970703,247.46694946289062)"
                                  opacity="1"
                                  style="display: block"
                                >
                                  <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      fill-opacity="0"
                                      stroke="rgb(255,255,255)"
                                      stroke-opacity="1"
                                      stroke-width="50"
                                      d=" M-86.24800109863281,22.211999893188477 C-86.24800109863281,22.211999893188477 -37.12900161743164,69.4520034790039 -37.12900161743164,69.4520034790039 C-37.12900161743164,69.4520034790039 90.49400329589844,-52.82600021362305 90.49400329589844,-52.82600021362305"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </g></svg
                        ></span>
                      </h1>
                      <div class="header_devInfo__bqnmB">
                        <div class="header_devName__6PmbF">
                          <a
                            ><span>{{ previewContent.developer }}</span></a
                          >
                        </div>
                        <div class="header_infoAds__yGLRx">
                          <div>
                            <span>{{ previewContent.ad }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="header_infoListContent__UlLT8">
                    <div class="header_infoListContentList__xkMAE">
                      <div class="header_infoListContentListWBlock__BFDyj">
                        <div class="header_infoListContentListBlock__D2C20">
                          <div class="header_infoListContentListBlockT__-Anx2">
                            {{ previewContent.rating }}<i class="google-material-icons" aria-hidden="true">star</i>
                          </div>
                          <div class="header_infoListContentListBlockB__5kNfV">
                            {{ previewContent.feedbacksAmount }} {{ staticTexts.infoReviews }}
                          </div>
                        </div>
                        <div class="header_infoListContentListBlock__D2C20">
                          <div class="header_infoListContentListBlockT__-Anx2">{{ previewContent.uploadsAmount }}</div>
                          <div class="header_infoListContentListBlockB__5kNfV">{{ staticTexts.infoDownloads }}</div>
                        </div>
                        <div class="header_infoListContentListBlock__D2C20">
                          <div class="header_infoListContentListBlockT__-Anx2">
                            <span class="header_infoListContentListBlockTIconCenter__jQQWg" aria-hidden="true">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                <rect fill="none" width="20" height="20"></rect>
                                <path
                                  fill="white"
                                  d="M10.54,11.09L8.66,9.22l-1.02,1.02l2.9,2.9l5.8-5.8l-1.02-1.01L10.54,11.09z M15.8,16.24H8.2L4.41,9.66L8.2,3h7.6l3.79,6.66 L15.8,16.24z M17,1H7L2,9.66l5,8.64V23l5-2l5,2v-4.69l5-8.64L17,1z"
                                ></path>
                              </svg>
                            </span>
                          </div>
                          <div class="header_infoListContentListBlockB__5kNfV">{{ staticTexts.infoEditorsChoice }}</div>
                        </div>
                        <div class="header_infoListContentListBlock__D2C20">
                          <div class="header_infoListContentListBlockT__-Anx2">
                            <img
                              class="header_infoListContentListBlockTIconAge__ERuTn"
                              src="/assets/lib-assets/modern-template/images/other_18.png"
                              alt="Rated for 18+"
                            />
                          </div>
                          <div class="header_infoListContentListBlockB__5kNfV">
                            <span
                              ><span>{{ staticTexts.infoRatedFor }} {{ previewContent.age }}</span></span
                            >
                            <div class="header_infoListContentListBlockBB__980US">
                              <i class="google-material-icons" aria-hidden="true">info</i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="header_btnContent__rH7Fv">
                <div class="header_btnContentInstall__UtT7y">
                  <div class="header_btnContentInstall_sub1__4I4Ui">
                    <div class="header_btnContentInstall_sub1cWiz__bCzJG">
                      <div class="header_btnIns_W1__MhKZ7">
                        <div>
                          <div>
                            <div class="header_btnIns_W4__mjnfw">
                              <button
                                *ngIf="isAppInstalled(); else installBtn"
                                (click)="open.emit(true)"
                                class="header_btnIns_Btn__uB2nz"
                              >
                                <div class="header_btnIns_BtnProg__SMou9">
                                  <div class="header_btnIns_BtnProgLine__m+nW7"></div>
                                </div>
                                <div class="header_btnIns_BtnTitle__ctqbc">{{ staticTexts.infoOpen }}</div>
                              </button>
                              <ng-template #installBtn>
                                <button (click)="install.emit(true)" class="header_btnIns_Btn__uB2nz">
                                  <div class="header_btnIns_BtnProg__SMou9">
                                    <div class="header_btnIns_BtnProgLine__m+nW7"></div>
                                  </div>
                                  <div class="header_btnIns_BtnTitle__ctqbc">
                                    {{
                                      installResult() === 'started' ? staticTexts.infoLoading : staticTexts.infoInstall
                                    }}
                                  </div>
                                </button>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="header_btnContentAddFav__-vdWi">
                  <div>
                    <div>
                      <div>
                        <div>
                          <div class="header_btnContentAddFavPB__+xxML">
                            <button class="header_btnContentAddFavBtn__-l9-l">
                              <span class="header_btnContentAddFavBtn_icon__80TSv" aria-hidden="true"
                                ><svg width="24" height="24" viewBox="0 0 24 24">
                                  <path
                                    d="M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z"
                                  ></path></svg></span
                              ><span class="header_btnContentAddFavBtn_txt__3-jmH" aria-hidden="true">{{
                                staticTexts.addToWishlist
                              }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="header_successInstallContainer__XLO2v">
                <div class="header_successInstallContainer_sub1__kTxDU">
                  <i class="google-material-icons" aria-hidden="true">devices</i
                  ><span>{{ staticTexts.appAvailability }}</span>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <div class="titleIcon_titleIconWrap__CeUGO">
            <div class="titleIcon_header__vWaK4">
              <div class="titleIcon_iconWrap__jy2dh">
                <picture>
                  <img alt="icon" [src]="config().logo?.image" />
                </picture>
              </div>
              <div class="titleIcon_titleInfo__GHmhK">
                <div class="titleIcon_title__BNesb">
                  {{ previewContent.name }}
                  @if (config().verificationCheckmark) {
                    <svg
                      viewBox="0 0 512 512"
                      preserveAspectRatio="xMidYMid meet"
                      style="
                        width: 32px;
                        height: 36px;
                        transform: translate3d(0px, 0px, 0px);
                        content-visibility: visible;
                        vertical-align: middle;
                        padding-bottom: 4px;
                      "
                    >
                      <defs>
                        <clippath id="__lottie_element_2">
                          <rect width="512" height="512" x="0" y="0"></rect>
                        </clippath>
                        <clippath id="__lottie_element_4">
                          <path d="M0,0 L512,0 L512,512 L0,512z"></path>
                        </clippath>
                      </defs>
                      <g clip-path="url(#__lottie_element_2)">
                        <g
                          clip-path="url(#__lottie_element_4)"
                          transform="matrix(0.6499999761581421,0,0,0.6499999761581421,-4.399993896484375,79.60000610351562)"
                          opacity="1"
                          style="display: block"
                        >
                          <g transform="matrix(1,0,0,1,256,256)" opacity="1" style="display: block">
                            <g opacity="1" transform="matrix(0.8999999761581421,0,0,0.8999999761581421,0,0)">
                              <path
                                fill="rgb(68,163,221)"
                                fill-opacity="1"
                                d=" M102.375,-248.5 C63,-263 32.5,-223.25 0.75,-222.625 C-31,-222 -63.75,-263 -101,-249.125 C-138.25,-235.25 -134,-184 -154.81199645996094,-159.375 C-175.62399291992188,-134.75 -229.5,-143.75 -248,-102.93800354003906 C-264.6600036621094,-66.18399810791016 -222,-31.5 -222,0.18700000643730164 C-222,33.25299835205078 -263,65.625 -248.375,102.81199645996094 C-233.75,140 -181.25,135.75 -158,156.75 C-134.75,177.75 -141,235.75 -99.75,249.125 C-58.5,262.5 -23.25,223 0.625,222.375 C24.5,221.75 62.874000549316406,261.5 101.56199645996094,249.25 C140.25,237 135.5,179.5 157.125,158 C178.75,136.5 234.75,139.5 249.5,101.875 C264.25,64.25 223,26.75 222.75,-1.25 C222.5,-29.25 262.5,-63 249.375,-101.25 C236.25,-139.5 183,-133.5 158.75,-156 C134.5,-178.5 141.75,-234 102.375,-248.5z"
                              ></path>
                            </g>
                          </g>
                          <g
                            transform="matrix(0.9929699897766113,0,0,1.0264699459075928,253.8919219970703,247.46694946289062)"
                            opacity="1"
                            style="display: block"
                          >
                            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                fill-opacity="0"
                                stroke="rgb(255,255,255)"
                                stroke-opacity="1"
                                stroke-width="50"
                                d=" M-86.24800109863281,22.211999893188477 C-86.24800109863281,22.211999893188477 -37.12900161743164,69.4520034790039 -37.12900161743164,69.4520034790039 C-37.12900161743164,69.4520034790039 90.49400329589844,-52.82600021362305 90.49400329589844,-52.82600021362305"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  }
                </div>
                <div class="titleIcon_devName__kprOh">{{ previewContent.developer }}</div>
                <div class="titleIcon_infoAds__RZru5">
                  <div class="titleIcon_extDataItem__aduY3">{{ previewContent.ad }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="iconInfo_iconInfoWrap__5yKCA">
            <div class="iconInfo_scrollCon__mCXY9" style="cursor: grab">
              <div class="iconInfo_item__vE2K7">
                <div class="iconInfo_icon__P5RKD">
                  {{ previewContent.rating }}
                  <svg width="18" height="18" viewBox="0 0 18 18">
                    <path d="M9 11.3l3.7 2.7-1.4-4.4L15 7h-4.5L9 2.5 7.5 7H3l3.7 2.6L5.3 14z"></path>
                    <path fill="none" d="M0 0h18v18H0z"></path>
                  </svg>
                </div>
                <div class="iconInfo_text__BRidj">
                  {{ previewContent.feedbacksAmount }} {{ staticTexts.infoReviews }}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="#757575">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M11 17h2v-6h-2v6zm1-15a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zM11 9h2V7h-2v2z"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="iconInfo_item__vE2K7">
                <div class="iconInfo_icon__P5RKD">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path
                      d="M10.5 11L8.7 9.3l-1 1 2.8 3 5.8-5.9-1-1-4.8 4.8zm5.3 5.2H8.2L4.4 9.7 8.2 3h7.6l3.8 6.7-3.8 6.5zM17 1H7L2 9.7l5 8.6V23l5-2 5 2v-4.7l5-8.6L17 1z"
                    ></path>
                  </svg>
                </div>
                <div class="iconInfo_text__BRidj">
                  {{ staticTexts.infoEditorsChoice }}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="#757575">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M11 17h2v-6h-2v6zm1-15a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zM11 9h2V7h-2v2z"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="iconInfo_item__vE2K7">
                <div class="iconInfo_icon__P5RKD">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M 0,0 H 24 V 24 H 0 Z"></path>
                    <path
                      d="M 20,4 H 4 v 16 h 16 z m 0,-2 c 1.104569,0 2,0.8954305 2,2 v 16 c 0,1.104569 -0.895431,2 -2,2 H 4 C 2.8954305,22 2,21.104569 2,20 V 4 C 2,2.9 2.9,2 4,2 Z"
                    ></path>
                    <path
                      d="m 14.59,9.425842 1.41,1.409986 -4,4 -4,-4 L 9.41,9.425842 11,11.005828 V 6.0000007 h 2 V 11.005828 Z M 17,17.835828 H 7 v -2 h 10 z"
                    ></path>
                  </svg>
                </div>
                <div class="iconInfo_text__BRidj">{{ previewContent.size }}</div>
              </div>
              <div class="iconInfo_item__vE2K7">
                <div class="iconInfo_icon__P5RKD">
                  <picture>
                    <source
                      srcset="/assets/lib-assets/modern-template/images/for_app_18_dark.png"
                      media="(prefers-color-scheme: dark)"
                    />
                    <source
                      srcset="/assets/lib-assets/modern-template/images/for_app_18.png"
                      media="(prefers-color-scheme: light)"
                    />
                    <img
                      [alt]="staticTexts.infoRatedFor + ' ' + previewContent.age"
                      src="/assets/lib-assets/modern-template/images/for_app_18.png"
                    />
                  </picture>
                </div>
                <div class="iconInfo_text__BRidj">
                  {{ staticTexts.infoRatedFor }} {{ previewContent.age }}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="#757575">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M11 17h2v-6h-2v6zm1-15a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zM11 9h2V7h-2v2z"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="iconInfo_item__vE2K7">
                <div class="iconInfo_icon__P5RKD">{{ previewContent.uploadsAmount }}</div>
                <div class="iconInfo_text__BRidj">{{ staticTexts.infoDownloads }}</div>
              </div>
            </div>
          </div>
          <div class="btnInstall_btnInstallWrap__7e2ql">
            <div class="btnInstall_wrap__Es3d9">
              <div class="btnInstall_button__HV+hr" (click)="open.emit(true)" *ngIf="isAppInstalled(); else installBtn">
                {{ staticTexts.infoOpen }}
              </div>
              <ng-template #installBtn>
                <div (click)="install.emit(true)" class="btnInstall_button__HV+hr" id="install-button">
                  {{ installResult() === 'started' ? staticTexts.infoLoading : staticTexts.infoInstall }}
                </div>
              </ng-template>
            </div>
          </div>
        }

        <div class="screen_wrap__tUG-6">
          <div class="screen_scrollCon__h2j57" style="cursor: grab">
            @for (bannerUrl of banners; track bannerUrl) {
              <div class="screen_item__J+GuZ">
                <picture>
                  <img alt="screen" [src]="bannerUrl" />
                </picture>
              </div>
            }
          </div>
        </div>
        <div class="blockInfo_wrap__dXLoU">
          <div class="blockInfo_titleWrap__3mSIz">
            <div class="blockInfo_title__aiyrK">{{ staticTexts.infoAboutGame }}</div>
            <div class="blockInfo_icon__m5Gvc" (click)="togglePopup('description')">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"></path>
              </svg>
            </div>
          </div>
          <div class="blockInfo_body__WnTfr aboutGame_desc__wyID0" [innerHTML]="previewContent.description"></div>
        </div>
        <div class="tags_wrap__0WZg+">
          <div class="tags_scrollCon__rV8yg">
            <div class="tags_item__kkZbf">{{ previewContent.category }}</div>
          </div>
        </div>
        <div class="blockInfo_wrap__dXLoU">
          <div class="blockInfo_titleWrap__3mSIz">
            <div class="blockInfo_title__aiyrK">{{ staticTexts.infoDataSafety }}</div>
            <div class="blockInfo_icon__m5Gvc">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"></path>
              </svg>
            </div>
          </div>
          <div class="blockInfo_body__WnTfr">
            {{ staticTexts.infoDataSafetyDescription }}
            <div class="dataSafety_wrapTI__uLHNm">
              <div class="dataSafety_secItem__2QaHO">
                <div class="dataSafety_icon__D5jZf">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                    <path
                      d="M18 16a3 3 0 00-2 .8l-7-4.1v-1.4l7-4.1a3 3 0 10-.9-1.5L8 9.8A3 3 0 003 12a3 3 0 005 2.2l7 4.1v.7a3 3 0 103-3zm0-12c.6 0 1 .5 1 1s-.5 1-1 1-1-.5-1-1 .5-1 1-1zM6 13c-.6 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1zm12 7c-.6 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1z"
                    ></path>
                  </svg>
                </div>
                <div class="dataSafety_info__ygg55">
                  {{ staticTexts.infoDataSharing }}
                  <div class="dataSafety_subInfo__GejAv">
                    <span>{{ staticTexts.infoDataSharingLearnMore1 }}</span> {{ staticTexts.infoDataSharingLearnMore2 }}
                  </div>
                </div>
              </div>
              <div class="dataSafety_secItem__2QaHO">
                <div class="dataSafety_icon__D5jZf">
                  <svg height="24px" viewBox="0 -960 960 960" width="24px">
                    <path
                      d="M260-160q-91 0-155.5-63T40-377q0-78 47-139t123-78q17-72 85-137t145-65q33 0 56.5 23.5T520-716v242l64-62 56 56-160 160-160-160 56-56 64 62v-242q-76 14-118 73.5T280-520h-20q-58 0-99 41t-41 99q0 58 41 99t99 41h480q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-48-22-89.5T600-680v-93q74 35 117 103.5T760-520q69 8 114.5 59.5T920-340q0 75-52.5 127.5T740-160H260Zm220-358Z"
                    ></path>
                  </svg>
                </div>
                <div class="dataSafety_info__ygg55">
                  {{ staticTexts.infoDataCollecting }}
                  <div class="dataSafety_subInfo__GejAv">
                    <span>{{ staticTexts.infoDataCollectingLearnMore1 }}</span>
                    {{ staticTexts.infoDataCollectingLearnMore2 }}
                  </div>
                </div>
              </div>
              <div class="dataSafety_more__iJ77w">{{ staticTexts.infoSeeDetails }}</div>
            </div>
          </div>
        </div>
        <div class="blockInfo_wrap__dXLoU">
          <div class="blockInfo_titleWrap__3mSIz">
            <div class="blockInfo_title__aiyrK">{{ staticTexts.chartsTitle }}</div>
            <div class="blockInfo_icon__m5Gvc">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"></path>
              </svg>
            </div>
          </div>
          <div class="blockInfo_body__WnTfr">
            <div class="ratingReview_rrInfo__yH3+K">
              {{ staticTexts.ratingsDescription }}
              <svg width="24" height="24" viewBox="0 0 24 24" fill="#757575">
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path
                  d="M11 17h2v-6h-2v6zm1-15a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zM11 9h2V7h-2v2z"
                ></path>
              </svg>
            </div>
            <div class="ratingReview_wrapRat__MSycJ">
              <div>
                <div class="ratingReview_ratingTitle__HYP8y">4.9</div>
                <div class="starRating_starList__OXpkk">
                  <div class="starRating_starItem__4y0tg starRating_starItemFill__35ABL">
                    <svg viewBox="0 0 96 96" width="32" height="32">
                      <path
                        d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"
                      ></path>
                    </svg>
                  </div>
                  <div class="starRating_starItem__4y0tg starRating_starItemFill__35ABL">
                    <svg viewBox="0 0 96 96" width="32" height="32">
                      <path
                        d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"
                      ></path>
                    </svg>
                  </div>
                  <div class="starRating_starItem__4y0tg starRating_starItemFill__35ABL">
                    <svg viewBox="0 0 96 96" width="32" height="32">
                      <path
                        d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"
                      ></path>
                    </svg>
                  </div>
                  <div class="starRating_starItem__4y0tg starRating_starItemFill__35ABL">
                    <svg viewBox="0 0 96 96" width="32" height="32">
                      <path
                        d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"
                      ></path>
                    </svg>
                  </div>
                  <div class="starRating_starItem__4y0tg">
                    <div class="starRating_starItemNotFill__Bue+-">
                      <svg viewBox="0 0 96 96" width="32" height="32">
                        <path
                          d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"
                        ></path>
                      </svg>
                    </div>
                    <div
                      class="starRating_starItem__4y0tg starRating_starItemFill__35ABL"
                      style="clip-path: inset(0px 10% 0px 0px)"
                    >
                      <svg viewBox="0 0 96 96" width="32" height="32">
                        <path
                          d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="ratingReview_review__WeJla">
                  {{ previewContent.feedbacksAmount | shortNumber }}
                  {{ staticTexts.infoReviews }}
                </div>
              </div>
              <div class="ratingReview_wRatLine__GeJpn">
                <div class="ratingReview_lineW__xKmWH">
                  <div class="ratingReview_lineNum__5FnLE">5</div>
                  <div class="ratingReview_lineBase__mV8Q0">
                    <div class="ratingReview_lineBaseFill__DnBbq" style="width: 93%"></div>
                  </div>
                </div>
                <div class="ratingReview_lineW__xKmWH">
                  <div class="ratingReview_lineNum__5FnLE">4</div>
                  <div class="ratingReview_lineBase__mV8Q0">
                    <div class="ratingReview_lineBaseFill__DnBbq" style="width: 5%"></div>
                  </div>
                </div>
                <div class="ratingReview_lineW__xKmWH">
                  <div class="ratingReview_lineNum__5FnLE">3</div>
                  <div class="ratingReview_lineBase__mV8Q0">
                    <div class="ratingReview_lineBaseFill__DnBbq" style="width: 1%"></div>
                  </div>
                </div>
                <div class="ratingReview_lineW__xKmWH">
                  <div class="ratingReview_lineNum__5FnLE">2</div>
                  <div class="ratingReview_lineBase__mV8Q0">
                    <div class="ratingReview_lineBaseFill__DnBbq" style="width: 1%"></div>
                  </div>
                </div>
                <div class="ratingReview_lineW__xKmWH">
                  <div class="ratingReview_lineNum__5FnLE">1</div>
                  <div class="ratingReview_lineBase__mV8Q0">
                    <div class="ratingReview_lineBaseFill__DnBbq" style="width: 0%"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ratingReview_wrapCom__EkEd5">
              @for (comment of sortedComments; track comment.author) {
                @if (comment.author || comment.commentContent) {
                  <div class="commentItem_wrap__DArc+">
                    <div class="commentItem_top__s89jN">
                      <div class="commentItem_avatarW__VD4J5">
                        <div>
                          <picture>
                            <img
                              alt="auth"
                              [src]="
                                comment.avatar && comment.avatar.image
                                  ? comment.avatar.image
                                  : 'assets/lib-assets/classic-template/images/logo_avatar_anonymous_color.png'
                              "
                            />
                          </picture>
                        </div>
                        <div class="commentItem_name__MQa35">{{ comment.author }}</div>
                      </div>
                      <div class="commentItem_btn__gSBG3">
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none"></path>
                          <path
                            d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div class="commentItem_rating__9oY6q">
                      <div class="starRating_starList__OXpkk">
                        @for (star of getArray(comment.rating); track star) {
                          <div
                            class="starRating_starItem__4y0tg starRating_starItemFill__35ABL"
                            style="width: 12px; height: 12px"
                          >
                            <svg viewBox="0 0 96 96" width="32" height="32">
                              <path
                                d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"
                              ></path>
                            </svg>
                          </div>
                        }
                      </div>
                      <span class="commentItem_date__Jtmov">{{
                        comment.date | objectToDate: 'commentDate' : contentLanguageCode()
                      }}</span>
                    </div>
                    <div class="commentItem_comment__zKpWK commentItem_min__W+Eh+">
                      {{ comment.commentContent }}
                    </div>
                    <div class="commentItem_like__CzGaH">
                      {{ comment.likes | shortNumber }} {{ staticTexts.ratingLikes }}
                    </div>
                    <div class="commentItem_wasRev__1f58E">
                      <div class="commentItem_text__o46jf">{{ staticTexts.ratingQuestion }}</div>
                      <div class="commentItem_btn__gSBG3">
                        <div class="commentItem_btnItem__14Ant">{{ staticTexts.ratingQuestionYes }}</div>
                        <div class="commentItem_btnItem__14Ant">{{ staticTexts.ratingQuestionNo }}</div>
                      </div>
                    </div>
                    @if (comment.answerAuthor || comment.answerContent) {
                      <div class="commentItem_resWrap__oJo+p">
                        <div class="commentItem_resTop__hYFUr">
                          <div class="commentItem_resAuth__2I+E0">{{ comment.answerAuthor }}</div>
                          <div class="commentItem_resDate__p6eky">
                            {{ comment.answerDate | objectToDate: 'replyDate' : contentLanguageCode() : comment.date }}
                          </div>
                        </div>
                        <div class="commentItem_resComm__HtYaq commentItem_min__W+Eh+">
                          {{ comment.answerContent }}
                        </div>
                      </div>
                    }
                  </div>
                }
              }
              <div class="ratingReview_more__mNU+1">{{ staticTexts.ratingAllReviews }}</div>
            </div>
          </div>
        </div>
        <div class="blockInfo_wrap__dXLoU">
          <div class="blockInfo_titleWrap__3mSIz">
            <div class="blockInfo_title__aiyrK">{{ staticTexts.detailsSupport }}</div>
            <div class="blockInfo_icon__m5Gvc">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M12 8l-6 6 1.4 1.4 4.6-4.6 4.6 4.6L18 14z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
              </svg>
            </div>
          </div>
          <div class="blockInfo_body__WnTfr blockInfo_slide__X4Hc8" hidden="">
            <div class="appSupport_item__G6Xg6">
              <div class="appSupport_icon__7YH9E">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 1L3 5v6c0 5.5 3.8 10.7 9 12 5.2-1.3 9-6.5 9-12V5l-9-4zm7 10c0 4.5-2.8 8.5-7 9.9-4.2-1.5-7-5.5-7-9.9V6.3l7-3.1 7 3.1V11z"
                  ></path>
                </svg>
              </div>
              <div>
                <div class="appSupport_title__tJUZH">{{ staticTexts.detailsPrivacyPolicy }}</div>
                <div class="appSupport_cont__ATx-O">{{ previewContent.developer }} ®</div>
              </div>
            </div>
          </div>
        </div>
        <div class="footerOther_gprp__EqEGF">
          <div class="footerOther_icon__7Uwwz">
            <svg width="24" height="24" viewBox="0 0 960.0 960.0">
              <path
                d="M280,760v-80L564,680q63,0 109.5,-40T720,540T673.5,440T564,400L312,400L416,504l-56,56L160,360L360,160l56,56L312,320L564,320q97,0 166.5,63T800,540T730.5,697T564,760L280,760Z"
              ></path>
            </svg>
          </div>
          <div>{{ staticTexts.googlePlayRefund }}</div>
        </div>
        <div class="footerOther_price__Lx4T+">{{ staticTexts.googlePlayVAT }}</div>
      </div>
      <div class="bWrap"></div>
    </div>
    <div class="mooterMenu_wrap__YALQk">
      <div class="mooterMenu_list__bdRSM">
        <div class="mooterMenu_item__fS3IM">
          <div class="mooterMenu_icon__LGeX7">
            <svg width="24" height="24" viewBox="0 0 24.0 24.0">
              <path
                d="M14.14 11.86a0.87 0.87 0 1 1 1.74 0 0.87 0.87 0 1 1-1.74 0m-1.6-2.47c-0.34 0.34-0.34 0.9 0 1.24s0.9 0.34 1.24 0 0.34-0.9 0-1.24c-0.35-0.34-0.9-0.34-1.24 0zm3.45 0.62a0.88 0.88 0 1 1 1.76 0 0.88 0.88 0 1 1-1.76 0m-1.86-1.86a0.88 0.88 0 1 1 1.76 0 0.88 0.88 0 1 1-1.76 0M9.64 7.51H8.39v1.87H6.51v1.25h1.88v1.88h1.25v-1.88h1.87V9.38H9.64z"
              ></path>
              <path
                d="M21.29 12.41c-0.15-0.88-0.32-1.82-0.48-2.76-0.09-0.53-0.09-0.53-0.16-0.91L20.59 8.4C20.16 5.85 17.95 4 15.33 4H8.67C6.05 4 3.84 5.85 3.41 8.39L3.35 8.73C3.28 9.11 3.28 9.11 3.19 9.64c-0.16 0.94-0.33 1.88-0.49 2.81-0.58 3.4-0.7 4.07-0.7 4.21 0 1.54 1.25 2.79 2.79 2.79 0.76 0 1.46-0.27 1.98-0.79l2.88-2.84h4.71l2.88 2.85c0.51 0.51 1.21 0.79 1.97 0.79 1.54 0 2.79-1.25 2.79-2.79 0-0.15-0.12-0.82-0.71-4.26zm-2.08 5.23c-0.29 0-0.53-0.09-0.69-0.26l-3.15-3.12L15.1 14H8.9l-3.41 3.38c-0.17 0.17-0.4 0.26-0.69 0.26-0.54 0-0.98-0.44-0.98-0.98 0 0.04 1.37-7.9 1.38-7.96 0.29-1.67 1.74-2.88 3.48-2.88h6.65c1.74 0 3.19 1.21 3.47 2.88 0.01 0.06 1.39 7.99 1.39 7.95-0.01 0.55-0.44 0.99-0.98 0.99z"
              ></path>
            </svg>
          </div>
          <div>{{ staticTexts.googlePlayGames }}</div>
        </div>
        <div class="mooterMenu_item__fS3IM">
          <div class="mooterMenu_icon__LGeX7">
            <svg width="24" height="24" viewBox="0 0 24.0 24.0">
              <path
                d="M6 13h3c1.1 0 2 0.9 2 2v3c0 1.1-0.9 2-2 2H6c-1.1 0-2-0.9-2-2v-3c0-1.1 0.9-2 2-2zm0 2v3h3v-3H6zm9-2h3c1.1 0 2 0.9 2 2v3c0 1.1-0.9 2-2 2h-3c-1.1 0-2-0.9-2-2v-3c0-1.1 0.9-2 2-2zm0 2v3h3v-3h-3zm0-11h3c1.1 0 2 0.9 2 2v3c0 1.1-0.9 2-2 2h-3c-1.1 0-2-0.9-2-2V6c0-1.1 0.9-2 2-2zm0 2v3h3V6h-3zM6 4h3c1.1 0 2 0.9 2 2v3c0 1.1-0.9 2-2 2H6c-1.1 0-2-0.9-2-2V6c0-1.1 0.9-2 2-2zm0 2v3h3V6H6z"
              ></path>
            </svg>
          </div>
          <div>{{ staticTexts.googlePlayApps }}</div>
        </div>
        <div class="mooterMenu_item__fS3IM">
          <div class="mooterMenu_icon__LGeX7">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M20.5 19l-5.7-5.7a6.5 6.5 0 10-1.5 1.5l5.7 5.7 1.5-1.5zM5 9.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z"
              ></path>
              <path fill="none" d="M0 0h24v24H0V0z"></path>
            </svg>
          </div>
          <div>{{ staticTexts.googlePlaySearch }}</div>
        </div>
        <div class="mooterMenu_item__fS3IM">
          <div class="mooterMenu_icon__LGeX7">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M14 2h3a3 3 0 013 3v14a3 3 0 01-3 3H4V2h10zm0 2h-3v3.6l1.5-1.2L14 7.7V4zm4 15V5c0-.5-.5-1-1-1h-1v8l-3.5-3L9 12V4H6v16h11c.5 0 1-.5 1-1z"
              ></path>
            </svg>
          </div>
          <div>{{ staticTexts.googlePlayBooks }}</div>
        </div>
      </div>
    </div>
  </main>
</div>

@if (isDescriptionPopupVisible) {
  <div
    class="popup"
    role="dialog"
    aria-modal="true"
    aria-labelledby="descModalTitle"
    (click)="togglePopup('description')"
    (keydown.escape)="togglePopup('description')"
    tabindex="-1"
  >
    <div class="popup-content" (click)="$event.stopPropagation()">
      <button class="popup-close" (click)="togglePopup('description')" aria-label="Close dialog">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.9 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"
            fill="#5f6368"
          />
        </svg>
      </button>

      <header class="popup-header">
        <img class="popup-icon" [src]="config().logo?.image" alt="" />
        <div class="popup-titles">
          <h2 id="descModalTitle" class="popup-title">{{ previewContent.name }}</h2>
          <div class="popup-subtitle">{{ staticTexts.infoAboutGame }}</div>
        </div>
      </header>

      <section class="popup-body">
        <div [innerHTML]="previewContent.description"></div>
      </section>
    </div>
  </div>
}
